import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import getStore from '../store/store';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { mutatorAction } from 'satcheljs';
import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';

export const addToSpamList = mutatorAction(
    'addToSpamList',
    (spamScenarioId: SpamScenarioId, spamItem: string, indexToEdit: number) => {
        const store = getSpamScenarioStore(spamScenarioId);

        // If store is not defined, just log error to track
        if (!store) {
            logUsage('AddToSpamListFailure', {
                spamScenarioId: spamScenarioId,
                indexToEdit: indexToEdit,
            });

            trace.error('AddToSpamList should have the Spam store initialized');

            return;
        }

        // If index is provided, edit inplace
        if (indexToEdit >= 0) {
            store.spamList[indexToEdit] = spamItem;
        } else {
            // This happens when we are adding a new item
            const spamList = store.spamList.slice();

            // Avoid duplicate entries.
            // VSO: 39038 enforce list size here and create error state
            const spamItemLC = spamItem.toLowerCase();
            if (spamList.every(spamItemL => spamItemL.toLowerCase() !== spamItemLC)) {
                spamList.unshift(spamItem);
                store.spamList = spamList;
            }
        }
    }
);

export const deleteFromSpamList = mutatorAction(
    'deleteFromSpamList',
    (spamScenarioId: SpamScenarioId, indexToDelete: number) => {
        const store = getSpamScenarioStore(spamScenarioId);
        if (store) {
            store.spamList.splice(indexToDelete, 1);
        } else {
            logUsage('DeleteFromSpamListFailure', {
                spamScenarioId: spamScenarioId,
                indexToDelete: indexToDelete,
            });

            trace.error('DeleteFromSpamList should have the Spam store initialized');
        }
    }
);

export const createSpamStore = mutatorAction(
    'createSpamStore',
    (spamScenarioId: SpamScenarioId, spamList: string[]) => {
        const initStore = {
            spamList: null,
            newSpamItem: null,
            indexToEdit: -1,
            searchQuery: '',
            errorMessage: '',
        };
        initStore.spamList = spamList ? [...spamList] : null;

        getStore().spamStores.set(spamScenarioId, initStore);
    }
);
